module.exports = __webpack_public_path__ + "static/media/Updates.11e7710c.svg";